import React, {FC, useEffect, useRef, useState} from "react";
import {getEnvVariables} from "helpers/getEnvVariables";
import {NuveiPayphoneProps} from "components/Nuvei/Nuvei";
import {format} from "date-fns";
import NcModal from "shared/NcModal/NcModal";
import {SuccessModal} from "components/SuccessModal/SuccessModal";
import {BuyOrderType} from "data/types";
import {useSaveOrderMutation} from "store/api";

const {
  REACT_APP_TOKEN_PAYPHONE,
  REACT_APP_STORE_ID_PAYPHONE,
  REACT_APP_URL_WEB,
} = getEnvVariables();

export const Payphone: FC<NuveiPayphoneProps> = ({
  amount,
  description,
  valueIva,
  haveIva,
  buyOrder,
  // setShowLoader,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const now = new Date();
  const formattedDate = format(now, "yyyy/MM/dd-HH:mm:ss");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [alertMessage, setAlert] = useState<string | null>(null);

  const [saveOrder] = useSaveOrderMutation();

  const url = `${REACT_APP_URL_WEB}payphone.html`;

  useEffect(() => {
    const sendMessageToIframe = () => {
      console.log("Enviando mensaje al iframe: ", amount, valueIva);
      const totalAmount = Math.round(amount * 100);
      const amountWithTax = haveIva
        ? Math.round(totalAmount / (1 + valueIva / 100))
        : 0;

      const amountWithOutTax = haveIva ? 0 : totalAmount;
      const tax = haveIva
        ? Math.round(((totalAmount / (1 + valueIva / 100)) * valueIva) / 100)
        : 0;
console.log(
  `${
    JSON.parse(localStorage.getItem("user")!)?._id
  }-${description.charAt(0)}${amount}-${formattedDate}`,
);
      if (iframeRef.current) {
        iframeRef.current.contentWindow?.postMessage(
          {
            token: REACT_APP_TOKEN_PAYPHONE,
            storeId: REACT_APP_STORE_ID_PAYPHONE,
            amount: totalAmount,
            amountWithTax: amountWithTax,
            amountWithOutTax: amountWithOutTax,
            tax: tax,
            email: JSON.parse(localStorage.getItem("user")!)?.email,
            clientTransactionId: `W-${
              JSON.parse(localStorage.getItem("user")!)?._id
            }-${description.charAt(0)}-${formattedDate}`,
            reference: buyOrder.order.devReference,
          },
          "*",
        );
      }
    };
    iframeRef.current?.addEventListener("load", sendMessageToIframe);
    return () => {
      iframeRef.current?.removeEventListener("load", sendMessageToIframe);
    };
  }, []);

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      console.log("Mensaje recibido del iframe:", event.data);
      if (event.data.url) {
        console.log("Parámetros:", event.data.params);
        console.log("data e:", event);
        if (event.data.params.id && event.data.params.clientTransactionId) {
          console.log(
            "llega client transaction id",
            event.data.params.clientTransactionId,
          );
          const {id, clientTransactionId} = event.data.params;
          let newBuyOrder: BuyOrderType = {...buyOrder};
          newBuyOrder.order.clientTxId = clientTransactionId;
          newBuyOrder.order.id = id;
          console.log("New buy order: ", newBuyOrder);
          const {data: orderResponse, error: saveOrderError} = await saveOrder(
            newBuyOrder
          );
          if (saveOrderError) {
            setAlert("Ocurrió un error, intenta de nuevo");
            setTimeout(() => setAlert(null), 2500);
            return;
          }

          if (orderResponse && orderResponse.meta.status === 201) {
            setShowSuccessModal(true);
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <>
      <iframe
        ref={iframeRef}
        src={url}
        // src="http://localhost:3000/payphone.html"
        title="Payphone"
        width={"100%"}
        height={"600px"}
      />
      <NcModal
        isOpenProp={showSuccessModal}
        modalTitle="Compra exitosa"
        contentExtraClass="max-w-md"
        triggerText=""
        renderContent={() => <SuccessModal />}
      />
      {alertMessage && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out opacity-90 hover:opacity-100 hover:scale-105 flex items-center gap-4">
          {alertMessage}
        </div>
      )}
    </>
  );
};
